// src/components/layout/AppLayout.tsx

import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import { clsx } from "clsx";

export default function AppLayout() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="min-h-screen bg-light">
      {/* Sidebar */}
      <Sidebar
        collapsed={collapsed}
        onToggle={() => setCollapsed(c => !c)}
      />

      {/* Main content area */}
      <div
        className={clsx(
          "flex flex-col min-h-screen transition-all duration-200",
          collapsed ? "ml-16" : "ml-60"
        )}
      >
        {/* Top bar */}
        <TopBar sidebarCollapsed={collapsed} />

        {/* Page content */}
        <main className="flex-1 pt-14">
          <div className="p-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}